
import React from 'react';
import {
  ReactFlow,
  Background,
  Controls,
  MiniMap,
  Panel,
  ConnectionLineType
} from '@xyflow/react';
import '@xyflow/react/dist/style.css';
import { Button } from '@/components/ui/button';
import { Settings, X } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';
import { SharePointNode } from './nodes/SharePointNode';
import { ActionNode } from './nodes/ActionNode';
import { ConditionNode } from './nodes/ConditionNode';
import { PolicyDetailsNode } from './nodes/PolicyDetailsNode';

// Define node types
const nodeTypes = {
  sharepoint: SharePointNode,
  action: ActionNode,
  condition: ConditionNode,
  policyDetails: PolicyDetailsNode,
};

interface PolicyFlowCanvasProps {
  nodes: any[];
  edges: any[];
  onNodesChange: any;
  onEdgesChange: any;
  onConnect: any;
  onNodeClick: any;
  onDragOver: any;
  onDrop: any;
  setReactFlowInstance: any;
  reactFlowWrapper: React.RefObject<HTMLDivElement>;
  isNodePanelOpen: boolean;
  setIsNodePanelOpen: (isOpen: boolean) => void;
}

export const PolicyFlowCanvas = ({
  nodes,
  edges,
  onNodesChange,
  onEdgesChange,
  onConnect,
  onNodeClick,
  onDragOver,
  onDrop,
  setReactFlowInstance,
  reactFlowWrapper,
  isNodePanelOpen,
  setIsNodePanelOpen
}: PolicyFlowCanvasProps) => {
  const isMobile = useIsMobile();

  return (
    <div
      className="flex-1 h-full"
      ref={reactFlowWrapper}
    >
      <ReactFlow
        nodes={nodes}
        edges={edges}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        onConnect={onConnect}
        onInit={setReactFlowInstance}
        onNodeClick={onNodeClick}
        onPaneClick={() => {}}
        nodeTypes={nodeTypes}
        connectionLineType={ConnectionLineType.SmoothStep}
        snapToGrid={true}
        fitView
        attributionPosition="bottom-right"
        onDragOver={onDragOver}
        onDrop={onDrop}
      >
        <Background />
        <Controls showInteractive={!isMobile} />
        {!isMobile && <MiniMap zoomable pannable />}

        <Panel position="top-right" className="flex gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={() => setIsNodePanelOpen(!isNodePanelOpen)}
            className="flex items-center gap-1"
          >
            {isNodePanelOpen ? <X className="h-4 w-4" /> : <Settings className="h-4 w-4" />}
            <span className={isMobile ? 'sr-only' : ''}>
              {isNodePanelOpen ? 'Close panel' : 'Show panel'}
            </span>
          </Button>
        </Panel>
      </ReactFlow>
    </div>
  );
};
